export default __webpack_public_path__ + "static/media/Faysal Bank Cheque.524e155f.jpg";